import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useTailNumberContext } from 'src/contexts/tail-number.context';
import { actionTypes } from 'src/ducks/tail-number.duck';
import { ITailNumber, ITailNumberForm } from 'src/models/tail-number.model';
import { getTailNumberStatus } from 'src/selectors/tail-number.selector';
import TailNumbersForm from '../tail-numbers-form/tail-numbers-form.component';
import style from '../tail-numbers-list/tail-numbers-list.module.scss';

const TailNumbersAdd: React.FC = () => {
  const { state, actions } = useTailNumberContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<ITailNumber> = {
    tailNumber: '',
    tailId: 0,
  };

  const addStatus = getTailNumberStatus(state, actionTypes.TAIL_NUMBER_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: ITailNumberForm = {
        tailNumber: data.tailNumber,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_TAIL_ADD_SUCCESS,
            formData.tailNumber ? formData.tailNumber : data.tailNumber
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_TAIL_NUMBER}
      content={
        <div className={style.content}>
          <TailNumbersForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default TailNumbersAdd;
